const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** "2026-09-11" → "September 11, 2026". Pure string math: no timezone drift between SSR and client. */
export const formatDate = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};

/** "webcenter-14c-upgrade" → "Webcenter 14c upgrade" (fallback label for unknown related paths). */
export const humanizeSlug = (slug: string) => {
  const s = slug.replace(/-/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
};
